import { Router } from '@angular/router';
var noInternetComponent = /** @class */ (function () {
    function noInternetComponent(router) {
        this.router = router;
        this.hostClass = false;
        this.hostClass = true;
    }
    noInternetComponent.prototype.ngOnInit = function () { };
    noInternetComponent.prototype.goHome = function () {
        this.router.navigate(['']);
    };
    return noInternetComponent;
}());
export { noInternetComponent };



// WEBPACK FOOTER //
// ./src/app/template/noInternet/noInternet.component.ts.pre-build-optimizer.js